"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var validation_utils_1 = require("./validation.utils");

var create_error_1 = require("./create-error");

var defaults_1 = require("../defaults");

var dimensions_1 = require("../dimensions");

exports.validateApron = function (apronBackSplash, defaults, builtInParts) {
  var error = undefined;

  if (!builtInParts || !builtInParts.towelRail && !builtInParts.withTissueDispenser) {
    defaults.apronHeight = Object.assign({}, defaults.apronHeight, {
      default: dimensions_1.defaultInputs.apronHeight.min,
      values: dimensions_1.defaultInputs.apronHeight
    });
  }

  if (builtInParts && (builtInParts.towelRail || builtInParts.withTissueDispenser)) {
    defaults.apronHeight = Object.assign({}, defaults.apronHeight, {
      default: dimensions_1.defaultInputs.apronHeightWithCutOuts.min,
      values: dimensions_1.defaultInputs.apronHeightWithCutOuts
    });

    if (apronBackSplash.apron === 'without') {
      error = create_error_1.createError({
        msg: "Value {{" + apronBackSplash.apron + "}} isn't assignable to selected type of {{" + builtInParts.towelRail + "}} or {{" + builtInParts.withTissueDispenser + "}}",
        code: 'NOT_ASSIGNABLE',
        inObject: 'apronBackSplash.apron',
        statusCode: 400
      });
    }

    if (apronBackSplash.apron === 'with') {
      if (apronBackSplash.apronHeight && apronBackSplash.apronHeight < defaults_1.defaults.apronBackSplash.apronHeight.values.max) {
        error = create_error_1.createError({
          msg: "Value {{" + apronBackSplash.apronHeight + "}} isn't assignable. Selected value of {{" + apronBackSplash.apronHeight + "}} is to small.",
          code: 'NOT_ASSIGNABLE',
          inObject: 'apronBackSplash.apronHeight',
          statusCode: 400
        });
      }
    }
  }

  defaults.apron.default = apronBackSplash.apron;
  return error ? error : defaults;
};

exports.validateApronHeight = function (apronHeight, defaults) {
  var error;
  var isInRange = validation_utils_1.inRange(apronHeight, defaults.apronHeight.values);

  if (!isInRange) {
    error = create_error_1.createError({
      msg: "Value {{" + apronHeight + "}} isn't assignable. To big or to small.",
      code: 'NOT_ASSIGNABLE',
      inObject: 'apronBackSplash.apronHeight',
      statusCode: 400
    });
  }

  return error || defaults;
};

exports.validateSurgeEdgeOrBackSplash = function (typeOfInstallation, apronBackSplash, defaults) {
  var error = undefined;

  switch (typeOfInstallation) {
    case 'left':
      defaults.positionOfEdgeOrBacksplash.default = null;
      defaults.positionOfEdgeOrBacksplash.values = ['left'];

      if (apronBackSplash.positionOfEdgeOrBacksplash) {
        if (apronBackSplash.positionOfEdgeOrBacksplash.indexOf('right') > -1) {
          error = create_error_1.createError({
            msg: "Value {{" + apronBackSplash.positionOfEdgeOrBacksplash + "}} isn't assignable to selected type of installation",
            code: 'NOT_ASSIGNABLE',
            inObject: 'apronBackSplash.positionOfEdgeOrBacksplash',
            statusCode: 400
          });
        }
      }

      break;

    case 'right':
      defaults.positionOfEdgeOrBacksplash.default = null;
      defaults.positionOfEdgeOrBacksplash.values = ['right'];

      if (apronBackSplash.positionOfEdgeOrBacksplash) {
        if (apronBackSplash.positionOfEdgeOrBacksplash.indexOf('left') > -1) {
          error = create_error_1.createError({
            msg: "Value {{" + apronBackSplash.positionOfEdgeOrBacksplash + "}} isn't assignable to selected type of installation",
            code: 'NOT_ASSIGNABLE',
            inObject: 'apronBackSplash.positionOfEdgeOrBacksplash',
            statusCode: 400
          });
        }
      }

      break;

    case 'without':
      defaults.positionOfEdgeOrBacksplash.default = null;
      defaults.positionOfEdgeOrBacksplash.values = [];

      if (apronBackSplash.positionOfEdgeOrBacksplash) {
        if (apronBackSplash.positionOfEdgeOrBacksplash.indexOf('right') > -1 || apronBackSplash.positionOfEdgeOrBacksplash.indexOf('left') > -1) {
          error = create_error_1.createError({
            msg: "Value {{" + apronBackSplash.positionOfEdgeOrBacksplash + "}} isn't assignable to selected type of installation",
            code: 'NOT_ASSIGNABLE',
            inObject: 'apronBackSplash.positionOfEdgeOrBacksplash',
            statusCode: 400
          });
        }
      }

      break;

    default:
      defaults.positionOfEdgeOrBacksplash.default = null;
      defaults.positionOfEdgeOrBacksplash.values = ['left', 'right'];
  }

  return error ? error : defaults;
};

exports.validateApronBackSplash = {
  validateApron: exports.validateApron,
  validateSurgeEdgeOrBackSplash: exports.validateSurgeEdgeOrBackSplash
};
exports.default = exports.validateApronBackSplash;